import { utils } from '@kurtosys/ksys-app-template';
import { TickHandlerOptions } from '../models/utils/TickHandlerOptions';

const DEFAULT_COUNT: number = 5;
const DEFAULT_INTERVALS: Array<number> = [
    0.01,
    0.02,
    0.05,
    0.1,
    0.2,
    0.5,
    1,
    2,
    5,
    10,
    20,
    50,
    100,
    200,
    500,
    1000,
    2000,
    5000,
    10000,
    20000,
    50000,
    100000,
    200000,
    500000,
    1000000,
    2000000,
    5000000,
    10000000,
    20000000,
    50000000,
    100000000,
    200000000,
    500000000,
];
export class TickHandler {
    options: TickHandlerOptions;

    constructor(options?: TickHandlerOptions) {
        this.options = this.orchestrateOptions(options);
    }

    orchestrateOptions(options?: TickHandlerOptions) {
        return utils.object.deepMergeObjects(this.defaultOptions, options);
    }

    get defaultOptions(): TickHandlerOptions {
        const response: TickHandlerOptions = {
            count: DEFAULT_COUNT,
            intervals: DEFAULT_INTERVALS,
        };
        return response;
    }

    getTicksForSeries(
        data?: Array<any>,
        seriesKeys?: Array<string>,
        point?: number
    ) {
        if (data && seriesKeys) {
            const getKeyFns = this.getFunctionsForSeriesKeys(seriesKeys);
            const domain = this.getDomain(data, getKeyFns);
            if (domain) {
                const { min, max } = domain;
                const ticks = this.getTicksAroundPoint(
                    utils.typeChecks.isUndefined(point) ? 1 : point,
                    max,
                    min
                );
                return ticks;
            }
        }
        return;
    }

    getTicksAroundPoint(point: number, max: number, min: number) {
        const {
            count = DEFAULT_COUNT,
            intervals = DEFAULT_INTERVALS,
        } = this.options;

        const actualMax = Math.max(max, point);
        const actualMin = Math.min(min, point);
        const gap = actualMax - actualMin;
        const bestInterval = intervals.find(
            interval => interval >= gap / count
        );
        const ticks: Array<number> = [];
        ticks.push(point);
        if (bestInterval) {
            let maxRunner = point;
            while (maxRunner < actualMax) {
                maxRunner += bestInterval;
                ticks.push(maxRunner);
            }
            let minRunner = point;
            while (minRunner > actualMin) {
                minRunner -= bestInterval;
                ticks.push(minRunner);
            }
        }
        return ticks.sort((a, b) => a - b);
    }

    getDomain(data: Array<any>, getKeyFns: Array<(row: any) => number>) {
        let min: number | null = null;
        let max: number | null = null;
        for (const row of data) {
            if (row) {
                for (const getKeyFn of getKeyFns) {
                    if (getKeyFn) {
                        const value = getKeyFn(row);
                        if (
                            !Number.isNaN(value) &&
                            !utils.typeChecks.isNullOrUndefined(value)
                        ) {
                            min = min === null ? value : Math.min(min, value);
                            max = max === null ? value : Math.max(max, value);
                        }
                    }
                }
            }
        }
        if (max === null) {
            max = 0;
        }
        if (min === null) {
            min = 0;
        }
        max = this.dataMaxFn(max);
        min = this.dataMinFn(min);
        return { max, min };
    }

    getFunctionsForSeriesKeys(series: Array<string>) {
        const response: Array<(row: any) => number> = [];
        for (const serie of series) {
            response.push((row: any) => row[serie]);
        }
        return response;
    }

    dataMinFn(dataMin: number) {
        return Math.floor(dataMin * 100) / 100;
    }

    dataMaxFn(dataMax: number) {
        return Math.ceil(dataMax * 100) / 100;
    }
}



// WEBPACK FOOTER //
// ./src/utils/TickHandler.ts